// development
// export const goRiceUrl = `http://localhost`
// for prod
export const goRiceUrl = ``;
export const expireCookie = 14400000; // 4 Saat
export const customSiteUrl = ``;
